import { ENDPOINT, HTTP_METHOD } from 'src/constants/api';
import { DTO } from './base.dto';
import { ResponseType } from 'axios';
import { ILoanProposal, IMortgageDetailsForm } from 'src/interfaces/mortgage-deal/mortgage-deal-details';
import { IGuarantor, IGuarantorRequest } from 'src/interfaces/mortgage-deal/invite-guarantor';

export interface ILoanProposalItem {
	id?: string;
	mortgagePropertyDetailId?: string;
	ltv?: number | string;
	loanRate?: number | string;
	loanPeriod?: number;
	interestPaymentPeriod?: number;
	proposalLoanAmountCurrency?: string;
	proposalLoanAmount?: number;
	interestCurrency?: string;
	interest?: number;
}

export class saveMortgageDealDetailsDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IMortgageDetailsForm;
	public url: string = ENDPOINT.SAVE_MORTGAGE_DEAL_DETAILS;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IMortgageDetailsForm) {
		super();
		this.body = body;
	}
}

export class GetMortgageDealDetailsDTO extends DTO {
	public param: { id: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.GET_MORTGAGE_DEAL_DETAILS;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { id: string }) {
		super();
		this.param = param;
	}
}

export class GetMortgageDealPropertyDetailsDTO extends DTO {
	public param: { id: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.GET_MORTGAGE_DEAL_PROPERTY_DETAILS;
	public method: HTTP_METHOD = HTTP_METHOD.GET;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { id: string }) {
		super();
		this.param = param;
	}
}

export interface FunderInvestDealRequestBody {
	mortgageDealId: string;
	loanProposalId: string;

	mortgagePropertyId: string;
}

export class SubmitInvestDealPropertyDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: FunderInvestDealRequestBody | undefined;
	public url: string = ENDPOINT.SUBMIT_INVEST_DEAL;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: FunderInvestDealRequestBody) {
		super();

		this.body = body;
	}
}
export interface IActionOnAdminProposedDealBody {
	proposalId: string;
	isApprove: boolean;
	mortgageId: string;
	propertyId: string;
}
export class ActionOnAdminProposedDealDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IActionOnAdminProposedDealBody;
	public url: string = ENDPOINT.FUNDER_ACTION_ON_DEAL;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IActionOnAdminProposedDealBody) {
		super();

		this.body = body;
	}
}

export interface ISubmitCounterProposalParam {
	propertyId: string;
}

export interface ISubmitCounterDealBody extends ILoanProposal {
	mortgageId: string;
	mortgagePropertyId: string;
}
export class SubmitCounterProposalDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: ISubmitCounterDealBody;
	public url: string = ENDPOINT.SUBMIT_COUNTER_PROPOSAL;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: ISubmitCounterDealBody) {
		super();

		this.body = body;
	}
}

export class SaveGuarantorDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IGuarantorRequest;
	public url: string = ENDPOINT.SAVE_GUARANTOR;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IGuarantorRequest) {
		super();
		this.body = body;
	}
}

export class DeleteGuarantorInvitationDTO extends DTO {
	public param: { id: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.DELETE_GUARANTOR_INVITATION;
	public method: HTTP_METHOD = HTTP_METHOD.DELETE;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { id: string }) {
		super();
		this.param = param;
	}
}

export class DeleteMortgageSupportingDocumentDTO extends DTO {
	public param: { documentId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.DELETE_MORTGAGE_DOC_FILE;
	public method: HTTP_METHOD = HTTP_METHOD.DELETE;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { documentId: string }) {
		super();
		this.param = param;
	}
}

export class SaveDraftMortgageDealDTO extends DTO {
	public param: { mortgageId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.SAVE_DRAFT_MORTGAGE_DEAL_FORM;
	public method: HTTP_METHOD = HTTP_METHOD.PUT;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { mortgageId: string }) {
		super();
		this.param = param;
	}
}

export class SubmitMortgageDealFormDTO extends DTO {
	public param: { mortgageId: string };
	public query: undefined;
	public body: undefined;
	public url: string = ENDPOINT.SUBMIT_MORTGAGE_DEAL_FORM;
	public method: HTTP_METHOD = HTTP_METHOD.PUT;
	public readonly responseType: ResponseType = 'json';
	constructor(param: { mortgageId: string }) {
		super();
		this.param = param;
	}
}

export class ResendEmailGuarantorDTO extends DTO {
	public param: undefined;
	public query: undefined;
	public body: IGuarantor;
	public url: string = ENDPOINT.RESEND_EMAIL_GUARANTOR;
	public method: HTTP_METHOD = HTTP_METHOD.POST;
	public readonly responseType: ResponseType = 'json';
	constructor(body: IGuarantor) {
		super();
		this.body = body;
	}
}
